import { DataGrid } from "@mui/x-data-grid";
import { subHistoryColumns } from "../../datatablesource";
import { useEffect, useState } from "react";

import fetchURLForm from "../../../../functions/fetchURLForm";
import { fetchUrl } from "../../../../functions/fetchUrl";

import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const SubHistoryTimWeBH = ({ table }) => {
  // console.log("Table: " + table)
  useState("Loading...");
  const today = new Date();

  const [dataOoredoo, setDataOoredoo] = useState([]);
  const [dataOmantel, setDataOmantel] = useState([]);

  const [dataMobily, setDataMobily] = useState([]);

  const [dataSTC, setDataSTC] = useState([]);
  const [dataBatelco, setDataBatelco] = useState([]);

  const [priceOM, setPriceOM] = useState(0);
  const [priceOoredoo, setPriceOoredoo] = useState(0);
  const [priceOmantel, setPriceOmantel] = useState(0);

  const [priceBH, setPriceBH] = useState(0);
  const [priceSTC, setPriceSTC] = useState(0);
  const [priceBatelco, setPriceBatelco] = useState(0);

  const [valueDateFrom, setValueDateFrom] = useState(today);
  const [valueDateTo, setValueDateTo] = useState(today);

  const columns = [
    {
      field: "count",
      headerName: "Count",
      width: 160,
    },
    {
      field: "type",
      headerName: "type",
      width: 160,
    },
    {
      field: "price",
      headerName: "price",
      width: 160,
    },
  ];

  console.log(dataOoredoo);

  useEffect(() => {
    // setDataOoredoo([]);
    // setDataOmantel([]);
    //"valueDateTo": "01-20-2023"

    const monthFromNumber = (valueDateFrom.getMonth() + 1).toString().padStart(2, "0");
    const dayFromNumber = valueDateFrom.getDate().toString().padStart(2, "0");
    const yearFromNumber = valueDateFrom.getFullYear();

    const monthToNumber = (valueDateTo.getMonth() + 1).toString().padStart(2, "0");
    const dayToNumber = valueDateTo.getDate().toString().padStart(2, "0");
    const yearToNumber = valueDateTo.getFullYear();

    const dateFrom = monthFromNumber + "-" + dayFromNumber + "-" + yearFromNumber;
    const dateTo = monthToNumber + "-" + dayToNumber + "-" + yearToNumber;

    const bodySend = {
      valueDate: dateFrom,
      valueToDate: dateTo,
    };

    const fetchData = async () => {
      const response = await fetchUrl({
        apiName: table,
        method: "POST",
        reqBody: bodySend
      });
      if (response.success) {
        // console.log(response.data.result);
        if (table === "koraclubtimwe/subHistoryOM" || table === "converseaitimwe/subHistoryOM" || table === "chefrecipestimwe/subHistoryOM") {
          const totalPriceOM = response.result.reduce((sum, item) => sum + (item.price * item.count), 0);

          const ooredooData = response.result.filter(item => item.type.includes('-oor') );
          const omantelData = response.result.filter(item => item.type.includes('-om'));

          const totalPriceOor = ooredooData.reduce((sum, item) => sum + (item.price * item.count), 0);
          const totalPriceOm = omantelData.reduce((sum, item) => sum + (item.price * item.count), 0);

          setDataOoredoo(ooredooData);
          setDataOmantel(omantelData);

          setPriceOoredoo(totalPriceOor);
          setPriceOmantel(totalPriceOm);

          setPriceOM(totalPriceOM);
        } else if (table === "scoretimwe/subHistorySA" || table === "beautytimwe/subHistorySA" || table === "assistanttimwe/subHistorySA") {
          // const totalPriceOM = response.result.reduce((sum, item) => sum + (item.price * item.count), 0);

          const mobilyData = response.result.filter(item => item.type.includes('-mobily'));

          // const totalPriceOor = ooredooData.reduce((sum, item) => sum + (item.price * item.count), 0);

          setDataMobily(mobilyData);

          // setPriceOoredoo(totalPriceOor);

          // setPriceOM(totalPriceOM);
        } else {
          const totalPriceBH = response.result.reduce((sum, item) => sum + (item.price * item.count), 0);

          const stcData = response.result.filter(item => item.type.includes('-stc'));
          const batelcoData = response.result.filter(item => item.type.includes('-Batelco'));

          const totalPriceSTC = stcData.reduce((sum, item) => sum + (item.price * item.count), 0);
          const totalPriceBatelco = batelcoData.reduce((sum, item) => sum + (item.price * item.count), 0);

          setDataSTC(stcData);
          setDataBatelco(batelcoData);

          setPriceSTC(totalPriceSTC);
          setPriceBatelco(totalPriceBatelco);

          setPriceBH(totalPriceBH);
        }
      }
    };
    fetchData();




  }, [table, valueDateFrom, valueDateTo]);

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ display: "inline-block", margin: "0 10px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From:"
              value={valueDateFrom}
              onChange={(newValue) => {
                setValueDateFrom(new Date(newValue));
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>
        <div style={{ display: "inline-block", margin: "0 10px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To:"
              value={valueDateTo}
              onChange={(newValue) => {
                setValueDateTo(new Date(newValue));
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>
      </div>

      {table === "koraclubtimwe/subHistoryOM" || table === "converseaitimwe/subHistoryOM" || table === "chefrecipestimwe/subHistoryOM" ?
        <>
          <h4 style={{ marginTop: '10px' }}>Total Price: {priceOM} OMR</h4>
          <div style={{ display: 'flex', gap: '4px' }}>
            <div style={{ width: '100%' }}>
              <h4 style={{ marginTop: '10px' }}>Ooredoo Weekly: Total {priceOoredoo} OMR</h4>
              <DataGrid
                className="ml-1"
                rows={dataOoredoo}
                columns={columns}
                pageSize={8}
                rowsPerPageOptions={[5]}
                getRowId={(data) => data.id}
                style={{ height: "60vh" }}
              />
            </div>

            <div style={{ width: '100%' }}>
              <h4 style={{ marginTop: '10px' }}>Omantel: Total {priceOmantel} OMR</h4>
              <DataGrid
                className="ml-1"
                rows={dataOmantel}
                columns={columns}
                pageSize={8}
                rowsPerPageOptions={[5]}
                getRowId={(data) => data.id}
                style={{ height: "60vh" }}
              />
            </div>
          </div>
        </>
        : table === "scoretimwe/subHistorySA" || table === "beautytimwe/subHistorySA" || table === "assistanttimwe/subHistorySA" ?
          <>
            <div style={{ display: 'flex', gap: '4px' }}>
              <div style={{ width: '100%' }}>
                <h4 style={{ marginTop: '10px' }}>Mobily</h4>
                <DataGrid
                  className="ml-1"
                  rows={dataMobily}
                  columns={columns}
                  pageSize={8}
                  rowsPerPageOptions={[5]}
                  getRowId={(data) => data.id}
                  style={{ height: "60vh" }}
                />
              </div>
            </div>
        </> :
          <>
            <h4 style={{ marginTop: '10px' }}>Total Price: {priceBH} BHD</h4>
            <div style={{ display: 'flex', gap: '4px' }}>
              <div style={{ width: '100%' }}>
                <h4 style={{ marginTop: '10px' }}>STC: Total {priceSTC} BHD</h4>
                <DataGrid
                  className="ml-1"
                  rows={dataSTC}
                  columns={columns}
                  pageSize={8}
                  rowsPerPageOptions={[5]}
                  getRowId={(data) => data.id}
                  style={{ height: "60vh" }}
                />
              </div>

              <div style={{ width: '100%' }}>
                <h4 style={{ marginTop: '10px' }}>Batelco: Total {priceBatelco} BHD</h4>
                <DataGrid
                  className="ml-1"
                  rows={dataBatelco}
                  columns={columns}
                  pageSize={8}
                  rowsPerPageOptions={[5]}
                  getRowId={(data) => data.id}
                  style={{ height: "60vh" }}
                />
              </div>
            </div>
          </>

      }
    </>

  );
};

export default SubHistoryTimWeBH;
